export default {
  data () {
    return {
      startAt: null,
      isLoading: false,
      searchByRequest: false
    }
  },
  mounted () {
    if (this.name !== 'new-sound-sound' || this.name !== 'new-sound-homeSound' || this.name !== 'new-sound-awaySound') {
      this.isLocalFilter = true
      return
    }
    const { id, scrollHandler, openList, localData } = this
    const elRefName = `file-input-${id}`
    const element = this.$refs[elRefName]

    this.startAt = localData.length

    if (!element) {
      return
    }

    element.addEventListener('click', openList)

    this.$once('hook:beforeDestroy', () => {
      this.$bus.$emit('reset-bell-list')
    })
  },
  methods: {
    openList () {
      const { scrollHandler } = this

      this.$refs.scrollContent.addEventListener('scroll', scrollHandler)
    },
    scrollHandler ({ target }) {
      if (this.isLoading) {
        return
      }

      const { startAt, name } = this
      const { scrollTop, scrollHeight, clientHeight } = target

      if (scrollTop > scrollHeight - clientHeight - 200) {
        this.isLoading = true

        if (this.searchByRequest) {
          this.filterDataWithRequest(this.localValue)
        } else {
          this.$bus.$emit('update-bell-list', { startAt, name })
        }
      }
    }
  },
  watch: {
    data (newVal, oldVal) {
      if (newVal.length > oldVal.length) {
        this.startAt = newVal.length
        this.isLoading = false
      } else {
        this.startAt = 100
        if (this.$refs.scrollContent) {
          this.$refs.scrollContent.removeEventListener('scroll', this.scrollHandler)
        }
        this.isLoading = false
      }
    },
    localValue (newVal) {
      if (newVal !== this.value.title) {
        this.searchByRequest = true
      }
    },
    localData (newVal) {
      if (newVal.length === this.recordsTotal) {
        this.$refs.scrollContent.removeEventListener('scroll', this.scrollHandler)
        this.isLoading = false
      }
    },
    opened (newVal) {
      if (!newVal && this.searchByRequest) {
        this.startAt = 0
      }
    }
  }
}
